import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { queryKeys as liquidityQueryKeys } from '../../../../liquidity-planner/api/query-keys';
import { useClient } from '../../client-api';
import { type SurplusItemSettingsDto, type SurplusItemSettingsUpdateDto, updateSurplusItem } from '../../generated/client';
import { queryKeys } from '../../query-keys';

export const useUpdateSurplusItem = (): UseMutationResult<SurplusItemSettingsDto, AxiosError, SurplusItemSettingsUpdateDto> => {
    const queryClient = useQueryClient();
    const { data: client } = useClient();

    return useMutation({
        mutationFn: (payload) => updateSurplusItem({ body: payload, path: { id: payload.id! } }).then((result) => result.data!),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.surplusPanelSettings(client?.partnerUuid) });
            queryClient.invalidateQueries({ queryKey: queryKeys.cashFlow(client?.partnerUuid) });
            queryClient.invalidateQueries({ queryKey: queryKeys.projection(client?.partnerUuid) });
            // The liquidity calculator now keeps its own per-item surplus selection, so refresh its
            // server-computed outputs whenever a surplus item (incl. its liquidity flag) changes.
            queryClient.invalidateQueries({ queryKey: liquidityQueryKeys.liquidityOverview(client?.partnerUuid) });
            queryClient.invalidateQueries({ queryKey: liquidityQueryKeys.liquidityCalculatorCalculation(client?.partnerUuid) });
        },
    });
};
